import React from 'react'
const n = (num: number, precision = 1) =>
  (+num.toFixed(precision)).toLocaleString('de')

const differenceStrings = {
  /*

    GERMAN

    */
  de: [
    [30, 10000, 'deutlich mehr', 'als'],
    [10, 30, 'mehr', 'als'],
    [-10, 10, 'ähnlich viel', 'wie'],
    [-30, -10, 'weniger', 'als'],
    [-1000, -30, 'deutlich weniger', 'als'],
  ],
  /*

    FRENCH

    */
  fr: [
    [30, 10000, 'beaucoup plus', 'que'],
    [10, 30, 'plus', 'que'],
    [-10, 10, 'autant', 'que'],
    [-30, -10, 'moins', 'que'],
    [-1000, -30, 'beaucoup moins', 'que'],
  ],
}

const getDifString = (
  value: number,
  compare: number,
  language: 'de' | 'fr'
) => {
  let difstring = ['', '']
  const percentOfCompare = (value * 100) / compare - 100
  differenceStrings[language].map(([min, max, text, pro]) => {
    if (percentOfCompare > +min && percentOfCompare <= +max)
      difstring = [text.toString(), pro.toString()]
  })
  return difstring
}
export const UserText = ({
  userInputs,
  userGenderData,
  LANGUAGE,
}: {
  userInputs: UserInputTypes
  userGenderData: FormatedUserDataGenderType
  LANGUAGE: 'de' | 'fr'
}) => {
  const { gender, perweek } = userInputs
  const { f, m, fSum, mSum, fAve, mAve, fMed, mMed } = userGenderData

  const stringGender_de = {
    /*

    GERMAN

    */
    user:
      gender === 'm'
        ? 'männlichen Umfrageteilnehmer'
        : 'weiblichen Umfrageteilnehmerinnen',
    other:
      gender === 'm' ? 'weiblichen Teilnehmerinnen' : 'männlichen Teilnehmer',
  }
  const stringGender_fr = {
    /*

    FRENCH

    */
    user:
      gender === 'm'
        ? 'participants à ce questionnaire'
        : 'participantes à ce questionnaire',
    other: gender === 'm' ? 'femmes' : 'hommes',
  }

  const stringGender = LANGUAGE === 'de' ? stringGender_de : stringGender_fr

  const countAbstinent = {
    m: m.find((f) => f.key === 0) || { v: 1 },
    f: f.find((f) => f.key === 0) || { v: 1 },
  }
  console.groupCollapsed('UserText')
  console.log({ f, m, countAbstinent })
  console.groupEnd()

  const countGender = {
    user: gender === 'm' ? mSum : fSum,
    other: gender === 'm' ? fSum : mSum,
  }

  const abstinentbyGender = {
    m: (countAbstinent.m.v * 100) / mSum,
    f: (countAbstinent.f.v * 100) / fSum,
  }

  const percentAbstinent = {
    user: gender === 'm' ? abstinentbyGender.m : abstinentbyGender.f,
    other: gender === 'm' ? abstinentbyGender.f : abstinentbyGender.m,
  }
  console.log({ percentAbstinent })
  const averageGender = {
    user: gender === 'm' ? mAve : fAve,
    other: gender === 'm' ? fAve : mAve,
  }

  const medianGender = {
    user: gender === 'm' ? mMed : fMed,
    other: gender === 'm' ? fMed : mMed,
  }

  const isAbstinent = !perweek

  if (LANGUAGE === 'fr')
    return (
      /*

  FRENCH

  */
      <>
        {isAbstinent && (
          <>
            <p>
              Comme <b>{n(percentAbstinent.user)}%</b> des {countGender.user}{' '}
              {stringGender.user}, vous ne consommez <b>pas d'alcool</b>.{' '}
              <b>La consommation moyenne</b> est de{' '}
              <b>
                {n(averageGender.user)}{' '}
                {averageGender.user !== 1 ? 'verres' : 'verre'}
              </b>{' '}
              d'alcool par semaine. <b>La consommation médiane</b> est de{' '}
              <b>
                {n(medianGender.user)}{' '}
                {medianGender.user !== 1 ? 'verres' : 'verre'}
              </b>{' '}
              (la moitié des participant{gender === 'f' ? 'e' : ''}s boivent
              davantage, l'autre moins).{' '}
            </p>
            <p>
              Les{' '}
              <b>
                {countGender.other} {stringGender.other}
              </b>{' '}
              qui ont participé à ce questionnaire boivent{' '}
              <b>en moyenne {n(averageGender.other)}</b> verres. Leur
              consommation médiane se situe à{' '}
              <b>
                {n(medianGender.other)}{' '}
                {medianGender.other > 1 ? 'verres' : 'verre'}
              </b>{' '}
              d'alcool par semaine. <b>{n(percentAbstinent.other)}%</b> ne
              boivent jamais d'alcool.
            </p>
          </>
        )}
        {!isAbstinent && (
          <>
            <p>
              Avec{' '}
              <b>
                {perweek} {perweek === 1 ? 'verre' : 'verres'} d'alcool par
                semaine,
              </b>{' '}
              vous buvez{' '}
              {getDifString(perweek, averageGender.user, LANGUAGE).join(' ')} la{' '}
              <b>
                moyenne ({n(averageGender.user)}{' '}
                {averageGender.user !== 1 ? 'verres' : 'verre'})
              </b>{' '}
              des{' '}
              <b>
                {countGender.user} {stringGender.user}
              </b>
              . La{' '}
              <b>
                consommation médiane s'élève à {n(medianGender.user)}{' '}
                {medianGender.user !== 1 ? 'verres' : 'verre'}
              </b>{' '}
              (la moitié des participant{gender === 'f' ? 'e' : ''}s boivent
              davantage, l'autre moins).
            </p>
            <p>
              Les{' '}
              <b>
                {countGender.other} {stringGender.other}
              </b>{' '}
              qui ont participé à ce questionnaire boivent en{' '}
              <b>moyenne {n(averageGender.other)}</b> verres d'alcool par
              semaine.{' '}
              <b>
                La consommation médiane se situe à {n(medianGender.other)}{' '}
                {medianGender.other !== 1 ? 'verres' : 'verre'}
              </b>{' '}
              d'alcool par semaine.{' '}
              <b>
                {n(percentAbstinent.other)}% s'abstiennent de boire de l'alcool.
              </b>
            </p>
          </>
        )}
      </>
    )
  /*

  GERMAN

  */
  return (
    <>
      {isAbstinent && (
        <>
          <p>
            <b>
              Wie {n(percentAbstinent.user)} Prozent der {countGender.user}{' '}
              {stringGender.user} leben Sie abstinent
            </b>{' '}
            oder trinken ganz selten Alkohol. Der <b>Durchschnittskonsum</b>{' '}
            liegt bei{' '}
            <b>
              {n(averageGender.user)}{' '}
              {averageGender.user !== 1 ? 'Standardgläser' : 'Standardglas'}
            </b>{' '}
            Alkohol pro Woche. Der <b>Median</b> bei{' '}
            <b>
              {n(medianGender.user)}{' '}
              {medianGender.user !== 1 ? 'Gläser' : 'Glas'}
            </b>{' '}
            (die Hälfte trinkt mehr, die andere weniger).{' '}
          </p>
          <p>
            Die{' '}
            <b>
              {countGender.other} {stringGender.other}
            </b>{' '}
            trinken im <b>Durchschnitt {n(averageGender.other)}</b> und im{' '}
            <b>
              Median {n(medianGender.other)}{' '}
              {medianGender.other !== 1 ? 'Standardgläser' : 'Standardglas'}
            </b>{' '}
            Alkohol pro Woche, <b>{n(percentAbstinent.other)} Prozent</b> sind
            ebenfalls abstinent oder trinken ganz selten Alkohol.
          </p>
        </>
      )}
      {!isAbstinent && (
        <>
          <p>
            Mit{' '}
            <b>
              {perweek} {perweek === 1 ? 'Standardglas' : 'Standardgläsern'}{' '}
              Alkohol pro Woche
            </b>{' '}
            trinken Sie{' '}
            {getDifString(perweek, averageGender.user, LANGUAGE).join(' ')} der{' '}
            <b>
              Durchschnitt ({n(averageGender.user)}{' '}
              {averageGender.user !== 1 ? 'Gläser' : 'Glas'})
            </b>{' '}
            der{' '}
            <b>
              {countGender.user} {stringGender.user}
            </b>
            . Der{' '}
            <b>
              Median beträgt {n(medianGender.user)}{' '}
              {medianGender.user !== 1 ? 'Gläser' : 'Glas'}
            </b>{' '}
            (die Hälfte trinkt mehr, die andere weniger).
          </p>
          <p>
            Die{' '}
            <b>
              {countGender.other} {stringGender.other}
            </b>{' '}
            trinken im <b>Durchschnitt {n(averageGender.other)}</b> und im{' '}
            <b>
              Median {n(medianGender.other)}{' '}
              {medianGender.other !== 1 ? 'Standardgläser' : 'Standardglas'}
            </b>{' '}
            Alkohol pro Woche,{' '}
            <b>
              {n(percentAbstinent.other)} Prozent sind abstinent oder trinken
              ganz selten Alkohol.
            </b>
          </p>
        </>
      )}
    </>
  )
}
